import Marionette from 'backbone.marionette';
import journalEventEmptyviewTmpl from '../templates/journal_event_emptyview.tpl';
export default Marionette.ItemView.extend({
  template: journalEventEmptyviewTmpl
});